module.exports = __webpack_public_path__ + "static/media/detail.196fb6a1.less";